<template>
  <dui-form
    id="cFormParent"
    ref="form"
    is-dialog
    :is-mobile="isMobile"
    :is-submit-mobile="false"
    :title="title"
    cancel-wording="Cancel"
    :max-width="600"
    :submitFormDispatchFn="$helpers.submitFormDispatchFn"
    :submitFormErrorFn="$helpers.submitFormErrorFn"
    @close-form="formClosed"
  >
    <!-- formBody -->
    <template v-slot:formBody>
      <ul class="dropdown-list">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="dropdown-item"
          :class="[{ 'dropdown-item-active': checkActive(item) }]"
        >
          <a class="item-info" @click="$emit('input', item)">
            <v-icon>{{ item.icon }}</v-icon>
            <div class="label-text">
              {{ item.text }}
            </div>
          </a>
        </li>
      </ul>
    </template>
  </dui-form>
</template>

<script>
export default {
  name: "MobileAppMultipleDropdown",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "List",
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    this.$nextTick(() => {
      if (typeof this.$refs.form !== "undefined") {
        this.$refs.form.toggleModal = true;
      }
    });
  },
  mounted() {},
  methods: {
    formClosed() {
      // https://stackoverflow.com/questions/59843415/vue-vuetify-modal-pattern-or-best-practide-design/59845638#59845638
      setTimeout(() => {
        // again this help to keep transition
        this.$emit("close");
      }, 150);
    },
    checkActive(item) {
      return (
        typeof this.value !== "undefined" &&
        this.value !== null &&
        this.value.name === item.name
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// ul
.dropdown-list {
  overflow: auto;
  max-height: 208px;
  list-style-type: none;
  padding: 0;

  // li
  .dropdown-item {
    list-style-type: none;
    padding: 0;

    + .dropdown-item {
      margin-top: 12px;
    }

    // active
    &.dropdown-item-active {
      .item-info {
        border-color: var(--bg);

        .label-text {
          font-weight: bold;
        }
      }
    }

    .item-info {
      display: flex;
      align-items: center;
      border: 1px solid $strokeGrey;
      border-radius: 8px;
      padding: 8px;
      color: $textColor;

      ::v-deep.v-icon {
        font-size: 18px;

        + .label-text {
          padding-left: 8px;
        }
      }

      .label-text {
        font-size: 12px;
      }
    }
  }
}
</style>
